import { render, staticRenderFns } from "./siSalesOrdersDetails.vue?vue&type=template&id=203167e0&scoped=true&"
import script from "./siSalesOrdersDetails.vue?vue&type=script&lang=js&"
export * from "./siSalesOrdersDetails.vue?vue&type=script&lang=js&"
import style0 from "./siSalesOrdersDetails.vue?vue&type=style&index=0&id=203167e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203167e0",
  null
  
)

component.options.__file = "siSalesOrdersDetails.vue"
export default component.exports